import { themeVariables } from "Components/theme";
import styled, { keyframes } from "styled-components";
export const SIZES = {
    DOT_RADIUS: 5
};
const ANIMATION_DURATION = 0.8;
const DOT_COLOR = themeVariables["brand-primary-500"];
const dotPulse = keyframes `
  0% { transform: scale(0); }
  100% { transform: scale(2); }
`;
export default {
    Container: styled.div `
    position: absolute;
    top: calc(50% - ${SIZES.DOT_RADIUS}px);
    left: calc(50% - ${SIZES.DOT_RADIUS}px);
    height: ${SIZES.DOT_RADIUS * 2}px;
    width: ${SIZES.DOT_RADIUS * 2}px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    align-content: center;
    justify-content: center;

    > span {
      position: absolute;
      transform: translateX(-50%) translateY(100%);
      bottom: -1em;
      display: grid;
      justify-content: center;
    }

    > div {
      position: relative;
      transform: scale(0);
      border-radius: 100%;
      border: ${SIZES.DOT_RADIUS}px solid ${DOT_COLOR};
      margin: ${SIZES.DOT_RADIUS * 2}px;
      opacity: 0.9;

      &:nth-child(1) {
        animation: ${dotPulse} ${ANIMATION_DURATION}s ease-in-out alternate infinite;
      }
      &:nth-child(2) {
        animation: ${dotPulse} ${ANIMATION_DURATION}s ease-in-out alternate
          ${ANIMATION_DURATION / 3}s infinite;
      }
      &:nth-child(3) {
        animation: ${dotPulse} ${ANIMATION_DURATION}s ease-in-out alternate
          ${(ANIMATION_DURATION * 2) / 3}s infinite;
      }
    }
  `
};
